import React from 'react';
import SwatchAndColor from "../../../views/color/SwatchAndColor.js";
import OpenInJohnDeereButton from "../../../views/color/OpenInJohnDeereButton.js";
import LocatorEquipmentLink from "./LocatorEquipmentLink.js";
import TagAssetLink from "./TagAssetLink.js";
export default {
  install: molten => {
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'assetLocators',
      attrName: 'assetLocators.swatchAndColor',
      renderer: (value, valueStyle, object, _context) => {
        return /*#__PURE__*/React.createElement(SwatchAndColor, {
          value: Array.isArray(value) ? value[0] : null,
          object,
          style: valueStyle
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      objectType: 'assetLocators',
      attrName: 'assetLocators.openInJohnDeereButton',
      renderer: (value, valueStyle, object, _context) => {
        return /*#__PURE__*/React.createElement(OpenInJohnDeereButton, {
          value: Array.isArray(value) ? value[0] : null,
          object,
          style: valueStyle
        });
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      id: 'recovr.renderer.detail.locatorEquipmentLink',
      objectType: 'locator',
      attrName: 'locator.equipmentId',
      renderer: (value, _style, object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(LocatorEquipmentLink, {
            value: Array.isArray(value) ? value[0] : null,
            object
          });
        }
        return null;
      }
    });
    molten.addPlugin('AttributeValueRenderer', {
      id: 'recovr.renderer.detail.tagAssetLink',
      objectType: 'tag',
      attrName: 'tag.assetId',
      renderer: (value, _style, object, _context) => {
        if (value) {
          return /*#__PURE__*/React.createElement(TagAssetLink, {
            value: Array.isArray(value) ? value[0] : null,
            object
          });
        }
        return null;
      }
    });
  }
};